import {create} from "zustand";
import {STATUS_NOT_FOUND} from "../../constants/httpStatusCodes";

const useIsNotFound = create(set => ({
  isNotFound: false,
  setNotFound: isNotFound =>
    set(() => ({
      isNotFound,
    })),
}));

const setIsNotFound = isNotFound =>
  useIsNotFound.getState().setNotFound(isNotFound);

const withNotFound = (requestPromiseFn, ...args) => {
  setIsNotFound(false);

  return requestPromiseFn(...args).catch(error => {
    if (error.status === STATUS_NOT_FOUND) {
      setIsNotFound(true);
    }

    return error;
  });
};

export {useIsNotFound, setIsNotFound, withNotFound};
